import React, { useState, useEffect } from 'react';
import CmpsAnimation from '../CmpsAnimation/CmpsAnimation';
import Typing from '../Typing/Typing';
import * as Utils from '../../services/utils';


function CmpsNotValid({msg}) {
  const [typing, setTyping] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setTyping(false);
      Utils.scrollToTop();
    }, 2200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {typing && <Typing wait={100} />}
      {!typing && (
      <CmpsAnimation wait={200} last={true}>
        <span className="bubble gray">{msg}</span>
      </CmpsAnimation>
      )}
    </>
  );
  
} 

export default CmpsNotValid;